import { alpha, type Theme } from '@mui/material';

import type { StyleObj } from '../../@types';
import { SKIN } from '../../types/enums';

const DEFAULT_DIALOG_STYLES: StyleObj = {
  backdrop: {},
  dialogPaper: {
    p: 3,
    borderRadius: 2,
    border: '1px solid',
    borderColor: 'divider',
    backgroundColor: 'background.paper',
    backgroundImage: 'none',
    color: 'text.primary',
  },
  dialogTitle: {
    p: 0,
    mb: 1.5,
    typography: 'h3',
    textAlign: 'center',
  },
  dialogContent: {
    p: 0,
    textAlign: 'center',
  },
  messageContainer: {},
  dialogMessage: {
    color: 'text.secondary',
  },
  dialogActions: {
    p: 0,
    pt: 3,
  },
  actionRow: {
    width: 1,
    flexDirection: 'row',
    gap: 2,
  },
  actionButton: {
    flex: 1,
    borderRadius: 2,
  },
  cancelButton: {
    color: 'neutral.300',
    borderColor: 'neutral.400',
    '&:hover': {
      borderColor: 'neutral.300',
      backgroundColor: 'transparent',
    },
  },
  confirmButton: {},
};

const NEOBET_DIALOG_STYLES: StyleObj = {
  backdrop: {
    backgroundColor: (theme: Theme) => alpha(theme.palette.neutral[900], 0.45),
  },
  dialogPaper: {
    p: 0,
    maxWidth: 420,
    overflow: 'hidden',
    borderRadius: 3,
    border: '1px solid',
    borderColor: 'neutral.500',
    backgroundColor: 'neutral.600',
    backgroundImage: 'none',
    color: 'text.primary',
    boxShadow: '0 20px 48px rgba(0, 0, 0, 0.36)',
  },
  dialogTitle: {
    px: 2,
    pt: 2.5,
    pb: 0,
    typography: 'h4',
    textAlign: 'center',
  },
  dialogContent: {
    p: 0,
    textAlign: 'center',
  },
  messageContainer: {
    px: 2,
    pt: 2,
  },
  dialogMessage: {
    typography: 'body3',
    color: 'neutral.100',
    fontWeight: 500,
    lineHeight: 1.25,
  },
  dialogActions: {
    px: 2,
    pt: 2,
    pb: 2,
  },
  actionRow: {
    width: 1,
    flexDirection: 'row',
    gap: 1,
  },
  actionButton: {
    flex: 1,
    minHeight: 40,
    borderRadius: 2,
    fontWeight: 700,
    textTransform: 'none',
    boxShadow: 'none',
  },
  cancelButton: {
    color: 'neutral.100',
    borderColor: 'neutral.400',
    backgroundColor: 'transparent',
    '&:hover': {
      borderColor: 'neutral.300',
      backgroundColor: 'neutral.500',
    },
  },
  confirmButton: {
    color: 'neutral.25',
    backgroundColor: 'secondary.450',
    '&:hover': {
      backgroundColor: 'secondary.400',
      boxShadow: 'none',
    },
  },
};

export const FORFEIT_BONUS_DIALOG_SKIN_STYLES = {
  [SKIN.BET365]: DEFAULT_DIALOG_STYLES,
  [SKIN.GOLA]: DEFAULT_DIALOG_STYLES,
  [SKIN.NEOBET]: NEOBET_DIALOG_STYLES,
};
